import React from 'react';
import Styled from '../styles/RolesFV.styled';
import { IRolesFerramentaVideo } from '../interfaces/components/IRolesFerramentaVideo';
import { bucketS3, caminhoAnexosFerramentaVideo } from 'constants/EnvironmentData';
import { Select } from 'antd';
import FVActionButtons from './FVActionsButton';

const RolesFerramentaVideo = ({ roles, deleteRole, handleEditForm }: IRolesFerramentaVideo) => {
    const getBucket = () => {
        return bucketS3() + caminhoAnexosFerramentaVideo();
    };

    return (
        <Styled.Container>
            <Styled.Title>Regras Ferramenta de Vídeo</Styled.Title>

            {roles && roles.length > 0 ? (
                roles.sort((a, b) => a.id - b.id).map(role => (
                    <Styled.CardRole.Container key={role.id}>
                        <Styled.CardRole.Title>{role.title}</Styled.CardRole.Title>
                        <Styled.RowBetween>
                            <Select
                                mode="multiple"
                                allowClear
                                style={{ width: '100%' }}
                                placeholder="Categorias exclusivas"
                                size="large"
                                value={role?.categorias.map((c: any) => c.categoria.nome)}
                                open={false}
                            />
                            <FVActionButtons
                                onDelete={() => deleteRole(role.id)}
                                onEdit={() => handleEditForm(role)}
                                msgDelete="Tem certeza que deseja deletar esta regra?"
                            />
                        </Styled.RowBetween>
                        <Styled.CardRole.Description dangerouslySetInnerHTML={{ __html: role?.description }} />
                        {role?.filePathRegua && <Styled.CardRole.Banner src={getBucket() + role?.filePathRegua} alt={role?.description} />}
                    </Styled.CardRole.Container>
                ))
            ) : (
                <Styled.NoRolesMessage>Nenhuma regra encontrada.</Styled.NoRolesMessage>
            )}
        </Styled.Container>
    );
};

export default RolesFerramentaVideo;
